import { useNotificationsStore } from '../../../stores/notificationsStore';
import { NotificationType } from '../../../stores/notificationsStore';
import { cartNotification } from '../../../helpers/cartNotification';
import { notificationMessage } from '../../../content/notificationMessage';
import { fetchCart } from '../../../services/cart';

export function useCartGetAddedProduct(): {
  showProductAdded: (event?: any) => Promise<void>;
  showProductRemoved: () => Promise<void>;
} {
  const showProductAdded = async (event?: any) => {
    await fetchCart();
    const { itemcode: itemCode, quantity } = event?.detail ?? { itemcode: '', quantity: 0 };
    const notification = cartNotification(itemCode, quantity);
    useNotificationsStore.setState({ notifications: [notification] });
  };

  const showProductRemoved = async () => {
    await fetchCart();
    useNotificationsStore.setState({
      notifications: [
        {
          type: NotificationType.REMOVED_FROM_CART,
          timeout: 5000,
          message: notificationMessage[NotificationType.REMOVED_FROM_CART],
          expires: Date.now() + 5000,
        },
      ],
    });
  };
  return { showProductAdded, showProductRemoved };
}
